<div class="m-b-1" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="1rem">
	<mat-button-toggle-group
		(change)="detect()"
		[(ngModel)]="currentDestinationType"
		[disabled]="inputConfig.destination"
		fxFlex="100"
		ngDefaultControl
	>
		<mat-button-toggle [value]="DESTINATION_TYPES.CITY" fxFlex>Destination City</mat-button-toggle>
		<mat-button-toggle [value]="DESTINATION_TYPES.REGION" fxFlex
			>Destination Region</mat-button-toggle
		>
		<mat-button-toggle [value]="DESTINATION_TYPES.STATES" fxFlex
			>Destination States</mat-button-toggle
		>
	</mat-button-toggle-group>
</div>

<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="1rem">
	<mat-form-field *ngIf="currentDestinationType == DESTINATION_TYPES.CITY" fxFlex="100">
		<input
			#LocationCtrl="ngModel"
			(setAddress)="getAddressOnChange($event, 'destination')"
			[(ngModel)]="destination"
			[disabled]="inputConfig.destination"
			appGoogleLocation
			matInput
			name="destination"
			placeholder="Destination"
			required
			type="text"
		/>
	</mat-form-field>

	<mat-form-field *ngIf="currentDestinationType == DESTINATION_TYPES.REGION" fxFlex="100">
		<mat-chip-list #chipList aria-label="Fruit selection">
			<mat-chip
				(removed)="remove(i)"
				*ngFor="let destination of selectedDestinations; let i = index"
				[removable]="true"
				[selectable]="true"
			>
				{{ destination }}
				<mat-icon matChipRemove>cancel</mat-icon>
			</mat-chip>
			<input
				#destinationRegion
				(matChipInputTokenEnd)="selected($event)"
				[disabled]="inputConfig.destination"
				[formControl]="destinationListCtrl"
				[matAutocomplete]="auto"
				[matChipInputAddOnBlur]="true"
				[matChipInputFor]="chipList"
				[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
				placeholder="Select Destination Region"
			/>
		</mat-chip-list>
		<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
			<mat-option *ngFor="let region of filteredDestinations | async" [value]="region.regionName">
				{{ region.regionName }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>

	<mat-form-field *ngIf="currentDestinationType == DESTINATION_TYPES.STATES" fxFlex="100">
		<mat-chip-list #chipList aria-label="Fruit selection">
			<mat-chip
				(removed)="remove(i)"
				*ngFor="let destination of selectedDestinations; let i = index"
				[removable]="true"
				[selectable]="true"
			>
				{{ destination }}
				<mat-icon matChipRemove>cancel</mat-icon>
			</mat-chip>
			<input
				#statesList
				(matChipInputTokenEnd)="addState($event); statesList.value = ''"
				[disabled]="inputConfig.destination"
				[matChipInputAddOnBlur]="true"
				[matChipInputFor]="chipList"
				[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
				placeholder="Enter state seperated by comma (,) and press enter. (All states should be two letter abbreviations)"
			/>
		</mat-chip-list>
	</mat-form-field>
</div>
